module.exports = __webpack_public_path__ + "img/MIDI-arpeggiator-plugin-vst-green.56223a52.png";